import React, { FC } from 'react'
import 'stacked-alpha-video'

import { styled } from '@linaria/react'

import { breakpoints } from 'components/designSystem/shared/breakpoints'

const StyledAlphaVideo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  stacked-alpha-video {
    width: 30vw;
    object-fit: contain;

    @media (max-width: ${breakpoints.mobile - 1}px) {
      width: 100%;
    }

    /** Рекомендация из https://github.com/jakearchibald/stacked-alpha-video */
    display: inline-block;
  }

  stacked-alpha-video video {
    display: none;
  }
`

export const AlphaVideo: FC<{
  av1: string
  hevc: string
}> = ({ av1, hevc }) => {
  return (
    <StyledAlphaVideo>
      {/* https://github.com/jakearchibald/stacked-alpha-video */}
      <stacked-alpha-video>
        <video
          autoPlay
          playsInline
          muted
          controls={false}
          loop={true}
          preload="none"
          crossOrigin="anonymous"
        >
          <source
            src={av1}
            type="video/mp4; codecs=av01.0.08M.08.0.110.01.01.01.1"
          />
          <source src={hevc} type="video/mp4; codecs=hvc1.1.6.H120.b0" />
        </video>
      </stacked-alpha-video>
    </StyledAlphaVideo>
  )
}
